import Entity from './entity'

export default class Producent extends Entity  {
    namn: string
    aktor: string
    apiUrl?: string
    dokUrl?: string
    format?: string
    licens?: string
    version?: string

    constructor(namn: string, aktor: string) {
        super()
        this.namn = namn
        this.aktor = aktor
    }
}

